import type { Boss, BossSpriteRuntime } from './types'
import { knightGaitPoseKey } from './knight_gait'

// 騎士：歩きの途中 (1歩を運んでいる広い構え walk_reach) から攻撃へ移る時、溜めの最初の絵が立ち姿 (idle) なので
//   広い構え → 立ち姿が1コマで跳ぶ (10-14 測定 後ろ足 58〜66px・兜 横 13〜20px・docs/research/2026-10-14-knight-art-measure.md K-4)。
// 既定 (2026-10-15 配布版・ユーザー パック 1014c C-3「入れる」): その立ち姿の間だけ、最初の 100ms を揃えかけの絵 (walk_passing) で描く (描画のみ)。
//   10-08 の構え直しの足寄せ (src/knight_rest.ts) と同じ型。新しい絵は使わない。溜めの絵が立ち姿以外 (構え) に替わったら即やめる。
// 前の版 (挟まない) = DEV ?knightWalkBridge=0 (off)。URL は game.ts の DEV の箱だけが読む。
export const KNIGHT_WALK_BRIDGE_MS = 100
let bridgeOn = true
export function setKnightWalkBridge(value: string | null): void { bridgeOn = value !== '0' && value !== 'off' }
export function knightWalkBridgeEnabled(): boolean { return bridgeOn }

/** 1 tick 進める (sprites.ts の updateBossSpriteRuntime から)。 */
export function advanceKnightWalkBridge(ss: BossSpriteRuntime, boss: Boss, dt: number, telegraphImage: string | null): Partial<BossSpriteRuntime> {
  if (!bridgeOn || boss.id !== 'vigil-knight') return {}
  // 待機中は「いま描いている歩きの絵」を覚える (state が telegraph へ替わった tick には歩きの状態がもう無い)。
  const lastWalkPose = boss.state === 'idle' ? knightGaitPoseKey(boss) ?? undefined : undefined
  let remaining = Math.max(0, (ss.walkBridgeRemainingMs ?? 0) - dt * 1000)
  if (boss.state === 'telegraph' && ss.walkBridgeLastPose === 'walk_reach' && boss.hp > 0) remaining = KNIGHT_WALK_BRIDGE_MS
  if (boss.state !== 'telegraph' || boss.hp <= 0 || (telegraphImage != null && telegraphImage !== 'idle')) remaining = 0
  return { walkBridgeLastPose: lastWalkPose, walkBridgeRemainingMs: remaining }
}

/** 溜めの頭の立ち姿を揃えかけの絵へ替える (描画のみ)。 */
export function knightWalkBridgeKey(boss: Boss, ss: BossSpriteRuntime, timelineImage: string | null | undefined, playing: boolean): 'walk_passing' | null {
  return bridgeOn && playing && boss.id === 'vigil-knight' && boss.hp > 0 && boss.state === 'telegraph'
    && timelineImage === 'idle' && (ss.walkBridgeRemainingMs ?? 0) > 0 ? 'walk_passing' : null
}
